import React from "react";
import { Car } from "lucide-react";

const GaragisteHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-fabre-green via-fabre-teal to-fabre-darkgreen text-white py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-32 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>

      <div className="relative container mx-auto px-4">
        <div className="max-w-5xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-full p-4">
              <Car className="w-12 h-12 text-white" />
            </div>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold mb-6 leading-tight">
            Solutions déchets
            <span className="block text-3xl sm:text-4xl lg:text-5xl mt-2 text-fabre-lightgreen">
              pour Garagistes
            </span>
          </h1>
          
          <div className="w-24 h-1.5 bg-white/30 mx-auto mb-8 rounded-full"></div>
          
          <p className="text-xl md:text-2xl opacity-90 leading-relaxed mb-12 max-w-4xl mx-auto">
            Gestion complète et conforme des déchets automobiles. Huiles, batteries, pneus, métaux : 
            nous prenons tout en charge pour votre garage.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button 
              onClick={() => document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-fabre-green px-8 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              Devis gratuit garage
            </button>
            <a 
              href="tel:+33565787900"
              className="bg-fabre-lightgreen text-fabre-darkgreen px-8 py-4 rounded-xl font-bold text-lg hover:bg-white transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              05 65 78 79 00
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
              <div className="text-2xl font-bold">95%</div>
              <div className="text-sm opacity-90">Valorisation</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
              <div className="text-2xl font-bold">48h</div>
              <div className="text-sm opacity-90">Intervention</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
              <div className="text-2xl font-bold">25</div>
              <div className="text-sm opacity-90">Ans expertise</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
              <div className="text-2xl font-bold">100%</div>
              <div className="text-sm opacity-90">Conforme</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-[50px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path fill="#ffffff" fillOpacity="1" d="M0,32L80,42.7C160,53,320,75,480,74.7C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default GaragisteHero;